import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data_chart",
  "use": "icon-data_chart-usage",
  "viewBox": "0 0 34.237 34.579",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.237 34.579\" id=\"icon-data_chart\"><path d=\"M36.526,0a3.466,3.466,0,0,1,3.419,3.516V26.007l-7.35-7.448L29.1,22.1l-9.817-9.939L5.781,25.836V3.516A3.492,3.492,0,0,1,9.249,0ZM29.1,25.861l3.516-3.516,7.4,7.448v1.294a3.486,3.486,0,0,1-3.468,3.492H9.249A3.523,3.523,0,0,1,6.782,28.6l12.5-12.65L29.1,25.861Zm3.15-14.725a2.711,2.711,0,1,0-2.686-2.711A2.7,2.7,0,0,0,32.253,11.136Zm0,0\" transform=\"translate(-5.781)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol